import { userStorage } from '@/configs/storages/browser';

export const getDeviceId = (value?: string) => {
  const storageKey = 'device_id';
  let deviceId = value ? '' : userStorage.getItem(storageKey);
  if (!deviceId) {
    deviceId = value || crypto.randomUUID();
    userStorage.setItem(storageKey, deviceId);
  }
  return deviceId;
};

export const getDeviceType = () => {
  const platform = navigator.platform.toLowerCase();
  if (location.protocol.includes('http')) {
    return 3;
  }
  if (platform.includes('win')) {
    return 4;
  }
  if (platform.includes('mac')) {
    return 5;
  }
  return 3;
};

export const isDesktop = () => {
  return typeof (window as any).chrome?.send !== 'undefined';
};

export function getBrowserInfo() {
  const userAgent = navigator.userAgent;
  let browserName = null;
  let browserVersion = null;
  let platform = null;

  if (userAgent.includes('Firefox')) {
    browserName = 'Firefox';
    browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)?.[1];
  } else if (userAgent.includes('Edg')) {
    browserName = 'Microsoft Edge';
    browserVersion = userAgent.match(/Edg\/([0-9.]+)/)?.[1];
  } else if (userAgent.includes('Chrome')) {
    browserName = 'Google Chrome';
    browserVersion = userAgent.match(/Chrome\/([0-9.]+)/)?.[1];
  } else if (userAgent.includes('Safari')) {
    browserName = 'Safari';
    browserVersion = userAgent.match(/Version\/([0-9.]+)/)?.[1];
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    browserName = 'Opera';
    browserVersion = userAgent.match(/(Opera|OPR)\/([0-9.]+)/)?.[2];
  }

  if (userAgent.includes('Windows')) {
    platform = 'Windows';
  } else if (userAgent.includes('Mac')) {
    platform = 'macOS';
  } else if (userAgent.includes('Linux')) {
    platform = 'Linux';
  } else if (userAgent.includes('Android')) {
    platform = 'Android';
  } else if (
    userAgent.includes('iOS') ||
    userAgent.includes('iPhone') ||
    userAgent.includes('iPad')
  ) {
    platform = 'iOS';
  }

  return {
    browserName: browserName || 'Unknown browser',
    browserVersion: browserVersion || 'Unknown version',
    platform: platform || 'Unknown platform',
  };
}

export function checkUrlFromAccountCenter() {
  const url = new URL(location.href);
  const params = Object.fromEntries(url.searchParams.entries());
  return params.code && params.scope && params.state;
}
